<template>
  <div class="body-main">
    <div class="dc-header">
      <van-row>
        <van-col span="6">
          <div class="dc-image">
            <van-image :src="headimgurl"></van-image>
          </div>
        </van-col>
        <van-col span="18">
          <div class="dc-title">
            <div class="cusName">{{ CusInfo.CUSTOMER_NAME }}</div>
            <div class="cusSex">{{ sexList[CusInfo.SEX] }}</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div>
      <van-row>
        <van-cell class="menu-item menu-first" border title="会员卡" is-link @click="callFun('cardlist')"/>

        <van-cell class="menu-item menu-first" border title="就诊人与地址" is-link @click="callFun('address')"/>
        <van-cell class="menu-item" title="预约记录" border is-link @click="callFun('booklist')"/>
        <van-cell class="menu-item" title="我的病历" border is-link @click="callFun('caselist')"/>
        <van-cell class="menu-item" title="我的医生" border is-link @click="callFun('mydoc')"/>

        <van-cell class="menu-item menu-first" title="待付费处方" is-link @click="callFun('unpaycase')"/>
        <van-cell class="menu-item" title="待付款预约单" is-link @click="callFun('unpaybook')"/>
      </van-row>
      <van-row>
        <img class="img-qrcode" :src="imgQrCode">
      </van-row>
    </div>
  </div>
</template>

<script setup>

import {getLocal,setLocal} from "@/common/js/utils";
import {customerBussiness, getWxUserInfo} from "@/service/MpServer";
import QrCode from 'qrcode'

export default {
  components: {},

  name: 'CusDocDetail',
  data() {
    return {
      CusInfo:{},
      headimgurl:"",
      imgQrCode:"",
      sexList:{"1":"男", "2":"女"},
    }
  },

  mounted() {
    // 获取当用微信信息
    let _this= this;
    getWxUserInfo(function (){
      _this.getCusInfo();

      let userInfo= getLocal("login_cus_info_"+ getLocal("login_cus_shop"));
      if (JSON.parse(userInfo))
        _this.headimgurl= JSON.parse(userInfo).headimgurl;
    });

    //本地测试临时用
    // setLocal("login_cus_shop", "DP01");
    // setLocal("login_cus_appid", "wx57e5cb2f979d370d");
    // setLocal("login_cus_openid_DP01", "o2x-iwQ1GHa7UpFQDW6rI333XOoo");
    // this.getCusInfo();
    // this.headimgurl= "https://picnew13.photophoto.cn/20190330/xingzoudelansekatongkonglong-32985856_1.jpg";
  },

  methods: {
    getCusInfo(){
      let _this= this;
      let param= {};
      customerBussiness("CUSTOMER", "getWCusInfo", param, function (data) {
        let cusList= JSON.parse(data).Table;
        if (cusList.length> 0)
          _this.CusInfo= cusList[0];

        QrCode.toDataURL(_this.CusInfo.CUSTOMER_ID)
          .then(img=> { _this.imgQrCode= img});
      });
    },

    callFun(aimUrl){
      if (aimUrl== "mydoc"){
        this.$router.push({path: '/CusMyDoc', query: { }});
        return;
      }

      let url="";
      let appcode= "";
      let appid= getLocal("login_cus_appid");

      if (aimUrl== "cardlist")
        url="CusCardList.html?code="+ appcode+ "&state="+ appid;

      else if (aimUrl== "address")
        url="CusAddressList.html?code="+ appcode+ "&state="+ appid;
      else if (aimUrl== "booklist")
        url="CusBookList.html?code="+ appcode+ "&state="+ appid;
      else if (aimUrl== "caselist")
        url="CusCaseList.html?code="+ appcode+ "&state="+ appid;
      // else if (aimUrl== "mydoc")
      //   url="CusMyDoc.html?code="+ appcode+ "&state="+ appid;

      else if (aimUrl== "unpaycase")
        url="CusUnPayList.html?code="+ appcode+ "&state="+ appid;
      else if (aimUrl== "unpaybook")
        url="CusUnpayBookList.html?code="+ appcode+ "&state="+ appid;

      url= window.location.host+ "/old/CusHtml/"+ url;
      let path= window.location.protocol+ "//"+ url;
      window.location.href= path;
    }
  },
}
</script>

<style scoped lang="less">
@import '../../common/style/mixin';

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
  font-size: 14px !important;
}
.body-main{
  background: #efeef3;
}

.dc-header{
  border-bottom: 2px solid #dedede;
  border-radius: 10px;
  border: 2px solid #dedede;
  height: 80px;

  .cusName{
    font-size: 18px;
    font-weight: 600;
    margin: 10px 0px 0px 10px;
  }
  .cusSex{
    font-size: 14px;
    font-weight: 400;
    margin: 5px 0px 0px 10px;
  }
}
.dc-image{
  margin: 10px 0px 0px 10px;
  width: 60px;
  height: 60px;
}

.menu-item{

}
.menu-first{
  border-top: 1px solid #f3f0f0;
  margin-top: 6px;
}

.img-qrcode{
  width: 150px;
  display: block;
  margin: 0 auto;
  margin-top: 10px;
}

</style>
